// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckoutRight_root__1S-nv","sectionHeader":"CheckoutRight_sectionHeader__3yesf","paystack":"CheckoutRight_paystack__18oaf"};